<!--
 * @Date: 2024-01-23 15:44:48
 * @LastEditTime: 2024-01-23 15:44:48
 * @Description: 中医
-->

<template>
  <div class="chinese-medicine-wrapper">
    <cube-loading v-if="isLoading" class="loading" />
    <div v-if="!isLoading">
      <!-- 头图&优惠券 -->
      <div class="chinese-medicine-topbg" />
      <div
        v-if="couponList.background_image"
        class="chinese-medicine-coupon"
        :style="{ backgroundImage: `url(${couponList.background_image})` }"
      >
        <img
          :src="
            hadAllget
              ? 'https://staff.chunyu.mobi/@/media/images/2024/01/26/534a/598c01874d05_w144_h46_.png'
              : 'https://resource.chunyu.mobi/@/media/images/2024/01/25/b6ab/24add050a5ba_w144_h46_.png'
          "
          :style="hadAllget ? { width: '70px' } : ''"
          class="chinese-medicine-coupon-top-button"
          @click="handleGetAllCoupon"
        />
        <div class="chinese-medicine-coupon-list">
          <img
            v-for="item in couponList.coupons"
            :key="item.coupon_event_id"
            class="chinese-medicine-coupon-list-item"
            :src="item.image"
            @click="handleGetCoupon(item)"
          />
        </div>
      </div>
      <!-- 口碑名医 -->
      <div class="chinese-medicine-doctors">
        <img
          class="chinese-medicine-doctors-title"
          src="https://resource.chunyu.mobi/@/media/images/2024/01/23/c884/9c7091009aca_w330_h62_.png"
        />
        <div class="chinese-medicine-doctors-list">
          <div
            v-for="item in famousDoctors"
            :key="item.doctor_id"
            class="chinese-medicine-doctors-list-item"
            :style="{ backgroundImage: `url(${item.image})` }"
            @click="handleReClick(item)"
          >
            <div class="chinese-medicine-doctors-goodat">
              {{ item.good_at }}
            </div>
            <span class="chinese-medicine-doctors-price"
              >¥{{ item.service_price }}
              <span class="chinese-medicine-doctors-price-qi">起</span></span
            >
          </div>
        </div>
      </div>

      <!-- 按症状 找医生 -->
      <div class="chinese-medicine-find-doctors">
        <div class="chinese-medicine-find-doctors-title">
          <img
            class="chinese-medicine-find-doctors-title-img"
            src="https://resource.chunyu.mobi/@/media/images/2024/01/23/9c4b/f56b1ea4f196_w330_h62_.png"
          />
          <div
            class="chinese-medicine-find-doctors-button"
            @click="
              handleReClick({ cy_redirect: findDoctors.more_doctor_redirect })
            "
          >
            更多医生
          </div>
        </div>
        <cube-scroll-nav-bar
          :current="labels[0]"
          :labels="labels"
          @change="changeHandler"
        />
        <div class="chinese-medicine-find-doctors-item-wrapper">
          <div
            v-for="item in findDoctors.tab_list[currentIndex].doctors"
            :key="item.tab_name"
            class="chinese-medicine-find-doctors-list-item"
            :style="{ backgroundImage: `url(${item.image})` }"
            @click="handleReClick(item)"
          >
            <div class="chinese-medicine-find-doctors-goodat">
              {{ item.good_at }}
            </div>
            <span class="chinese-medicine-find-doctors-price"
              >¥{{ item.service_price }}
              <span class="chinese-medicine-find-doctors-price-qi"
                >起</span
              ></span
            >
          </div>
        </div>
      </div>

      <!-- 中医小知识 -->
      <div class="chinese-medicine-knowledge">
        <img
          class="chinese-medicine-knowledge-title"
          src="https://resource.chunyu.mobi/@/media/images/2024/01/24/f681/35c11378047f_w330_h62_.png"
        />
        <swiper
          v-if="knowledgeCards.length"
          class="chinese-medicine-knowledge-swiper"
          :options="swiperOption"
        >
          <swiper-slide
            v-for="(item, index) in knowledgeCards"
            :key="index"
            class="swiper-slide"
          >
            <img
              :src="item"
              alt=""
              class="chinese-medicine-knowledge-swiper-img"
            />
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" />
      </div>

      <!-- 在线抓中药 -->
      <div class="chinese-medicine-prescribe">
        <img
          class="chinese-medicine-prescribe-title"
          src="https://resource.chunyu.mobi/@/media/images/2024/01/24/9400/aa3b434d28f8_w330_h60_.png"
        />
        <div class="chinese-medicine-prescribe-content">
          <img
            :src="buyDrug.drug_info.image"
            alt="春雨"
            class="chinese-medicine-prescribe-content-intro"
            @click="handleReClick(buyDrug.drug_info)"
          />
          <div
            class="chinese-medicine-prescribe-content-bottom"
            @click="
              handleReClick({ cy_redirect: buyDrug.more_doctor_redirect })
            "
          >
            <span class="chinese-medicine-prescribe-content-bottom-tip"
              >* 如无处方，需咨询医生在线开方</span
            >
            <div class="chinese-medicine-prescribe-content-bottom-button">
              咨询医生开方
            </div>
          </div>
        </div>
      </div>

      <!-- 中医健康科普 -->
      <div class="chinese-medicine-science-article">
        <img
          class="chinese-medicine-science-article-title"
          src="https://resource.chunyu.mobi/@/media/images/2024/01/24/fcb4/c04b73f11364_w330_h60_.png"
        />
        <div class="chinese-medicine-science-article-list">
          <div
            v-for="(item, index) in healthArticles"
            :key="item.title"
            class="chinese-medicine-science-article-item"
            @click="handleReClick(item)"
          >
            <div class="chinese-medicine-science-article-item-title">
              {{ item.title }}
            </div>
            <div class="chinese-medicine-science-article-item-info">
              <img
                :src="item.doctor.image"
                alt=""
                class="chinese-medicine-science-article-item-avatar"
              />
              <span
                class="chinese-medicine-science-article-item-name marginleft5"
                >{{ item.doctor.name }}</span
              >
              <span
                class="chinese-medicine-science-article-item-dtitle  marginleft5"
                >{{ item.doctor.title }}</span
              >
              <span
                class="chinese-medicine-science-article-item-hosipital  marginleft5"
                >{{ item.doctor.hospital_name }}</span
              >
            </div>
            <div
              v-if="index !== healthArticles.length - 1"
              class="chinese-medicine-science-article-split"
            />
          </div>
        </div>
      </div>

      <!-- 底部图 -->
      <img
        src="../../assets/images/chinese-medicine-bottombg.png"
        alt=""
        class="chinese-medicine-bottom-img"
      />
    </div>
  </div>
</template>

<script>
import {
  getChineseMedicineDetail,
  getChineseMedicineCoupon,
  getChineseMedicinUrl,
  isLogin,
} from '@/services/index';
import { doPoint } from '@/utils/index';
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import { visitRecordReport } from '@@/utils/pageVisitRecord.js';

const wx = require('weixin-js-sdk');

export default {
  data() {
    return {
      couponList: {},
      famousDoctors: [],
      findDoctors: {
        tab_list: [{ doctors: [] }],
      },
      labels: [],
      currentIndex: 0,
      buyDrug: {
        drug_info: {
          image: '',
        },
      },
      healthArticles: [],
      knowledgeCards: [],
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
        },
      },
      isLoading: false,
      isLogin: false,
      hadAllget: false,
    };
  },
  created() {
    this.getData();
    isLogin().then(res => {
      const { is_login } = res;
      this.isLogin = is_login;
    });
    this.handleVisitRecordReport();
    this.doPageView();
    this.setShareInfo();
  },
  methods: {
    /**
     * pageView打点
     */
    doPageView() {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromWechat()) {
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            app = 'weixin_mini';
          } else {
            app = 'h5';
          }
        });
      } else {
        app = 'h5';
      }
      console.log(app, 'app');
      doPoint('PageView', {
        app,
        page_readable_name: '春雨中医馆',
        page_title: '春雨中医馆',
      });
    },
    /**
     * 获取数据
     *
     * @param loading
     */
    getData(loading) {
      if (!loading) {
        this.isLoading = true;
      }

      getChineseMedicineDetail().then(resp => {
        console.log(resp, 'resp');
        this.famousDoctors = resp.famous_doctors;
        this.couponList = resp.coupon_list;
        const couponDatas = this.couponList.coupons;
        if (couponDatas) {
          // 检查是否所有的can_get都为false
          this.hadAllget = couponDatas.every(coupon => !coupon.can_get);
          console.log(this.hadAllget, 'hadAllget');
        }

        this.findDoctors = resp.find_doctor;
        this.knowledgeCards = resp.knowledge_cards;
        this.healthArticles = resp.health_articles;
        this.buyDrug = resp.buy_drug;
        const tlabels = [];
        resp.find_doctor.tab_list.forEach(element => {
          tlabels.push(element.tab_name);
        });
        this.labels = tlabels;
        this.isLoading = false;
      });
    },
    /**
     * 领取单个优惠券
     *
     * @param data 优惠券数据
     */
    handleGetCoupon(data) {
      if (!this.isLogin) {
        window.location.href = `${window.location.origin}/accounts/login/?next=${window.location.href}`;
        return;
      }
      if (!data.can_get) {
        this.$createToast({
          time: 1000,
          txt: '您已领取过',
          type: 'txt',
        }).show();
        return;
      }
      this.handleGetCouponRequest(data.coupon_event_id);
    },
    /**
     * 领取全部优惠券
     *
     * @param data 优惠券数据
     */
    handleGetAllCoupon() {
      if (!this.isLogin) {
        window.location.href = `${window.location.origin}/accounts/login/?next=${window.location.href}`;
        return;
      }
      const couponDatas = this.couponList.coupons;
      // 检查是否所有的can_get都为false
      const allFalse = couponDatas.every(coupon => !coupon.can_get);
      if (allFalse) {
        this.$createToast({
          time: 1000,
          txt: '您已领取过',
          type: 'txt',
        }).show();
        return;
      }
      const couponIds = couponDatas.map(coupon => coupon.coupon_event_id);
      const idsString = couponIds.join(',');
      this.handleGetCouponRequest(idsString);
    },
    /**
     * 优惠券请求
     *
     * @param id 优惠券id
     */
    handleGetCouponRequest(id) {
      const params = {
        coupon_event_id: id,
      };
      getChineseMedicineCoupon(params)
        .then(() => {
          this.$createToast({
            time: 1000,
            txt: '领取成功',
            type: 'txt',
          }).show();
          setTimeout(() => {
            this.getData('noLoading');
          }, 1200);
        })
        .catch(() => {
          this.$createToast({
            time: 1000,
            txt: '领取失败',
            type: 'txt',
          }).show();
        });
    },
    /**
     * 跳转
     *
     * @param data 跳转数据
     */
    async handleReClick(data) {
      let rurl = data.cy_redirect.target_scheme || '';
      console.log(rurl, 'rurl1');
      if (!rurl) {
        const params = {
          doctor_id: data.doctor_id || '',
        };
        const { url_link } = await getChineseMedicinUrl(params);
        rurl = url_link;
      }
      console.log(rurl, 'rur2');
      await this.handleVisitRecordReport({
        cy_redirect: JSON.parse(data.cy_redirect.click_info),
      });
      doPoint('AppClick', JSON.parse(data.cy_redirect.click_info)).then(() => {
        if (data.cy_redirect.target_type === 'wx_mini') {
          wx.miniProgram.navigateTo({
            url: rurl,
          });
        } else {
          window.location.href = rurl;
        }
      });
    },
    /**
     * 成单路径上报
     
     * @param extraInfo
     */
    handleVisitRecordReport(extraInfo) {
      return new Promise(resolve => {
        visitRecordReport({
          fromName: '',
          name: '春雨中医馆',
          extraInfo,
        }).then(() => {
          resolve();
        });
      });
    },
    /**
     * 设置分享信息
     */
    setShareInfo() {
      const url = window.location.href;
      const shareInfo = {
        title: '春雨中医馆',
        userName: 'gh_681d3fd5683f',
        mini_id: 'gh_681d3fd5683f',
        link: url,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
        mini_image:
          'https://staff.chunyu.mobi/@/media/images/2024/01/26/64db/ea183456b168_w420_h336_.png',
        wx_scene_timeline_desc: '口碑中医,在线坐诊',
      };
      cyShare.app(shareInfo);
    },
    changeHandler(cur) {
      const index = this.labels.indexOf(cur);
      console.log(index);
      this.currentIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.loading {
  position: fixed;
  top: 35%;
  left: 50%;
  z-index: 100;
  transform: translateX(-50%);
}
.chinese-medicine-wrapper {
  height: 100%;
  background-color: rgb(248, 244, 235);
  .chinese-medicine-topbg {
    position: relative;
    width: 100%;
    height: rem(145);
    background-image: url(../../assets/images/chinese-medicine-topbg.png);
    background-repeat: no-repeat;
    background-size: contain;
  }
  .chinese-medicine-coupon {
    position: relative;
    width: 100%;
    height: rem(146);
    background-repeat: no-repeat;
    background-size: contain;
    .chinese-medicine-coupon-list {
      position: absolute;
      bottom: rem(12);
      left: rem(21);
      display: flex;
      .chinese-medicine-coupon-list-item {
        width: rem(107);
        height: rem(90);
        margin-right: rem(6);
      }
    }
    .chinese-medicine-coupon-top-button {
      position: absolute;
      top: rem(11);
      right: rem(20);
      width: rem(70);
      height: rem(21);
    }
  }
  .chinese-medicine-doctors {
    margin-top: rem(20);
    .chinese-medicine-doctors-title {
      display: block;
      width: rem(163);
      height: rem(30);
      margin: 0 auto;
    }
    .chinese-medicine-doctors-list {
      display: grid;
      grid-row-gap: rem(9);
      grid-column-gap: rem(9);
      grid-template-columns: 1fr 1fr; /* 创建两列等宽的网格 */
      margin: rem(15) rem(10) rem(15) rem(10);
      padding: rem(10);
      background: #7c3212;
      border-radius: 4px;
      .chinese-medicine-doctors-list-item {
        position: relative;
        width: rem(162);
        height: rem(175);
        background-repeat: no-repeat;
        background-size: contain;
        .chinese-medicine-doctors-goodat {
          position: absolute;
          top: rem(90);
          left: rem(12);
          display: -webkit-box;
          width: rem(139);
          overflow: hidden;
          color: #4e4e4e;
          font-size: 12px;
          line-height: rem(16);
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
        .chinese-medicine-doctors-price {
          position: absolute;
          bottom: rem(7);
          left: rem(19);
          color: #ff6134;
          font-weight: 600;
          font-size: 14px;
        }
        .chinese-medicine-doctors-price-qi {
          color: #999;
          font-weight: 400;
          font-size: 10px;
        }
      }
    }
  }
  .chinese-medicine-find-doctors {
    margin-top: rem(15);
    .chinese-medicine-find-doctors-title {
      display: flex;
      align-items: center;
      .chinese-medicine-find-doctors-button {
        width: rem(64);
        height: rem(23);
        color: #fff;
        font-weight: 500;
        font-size: rem(12);
        line-height: rem(23);
        text-align: center;
        background: #995638;
        border-radius: rem(13);
      }
      .chinese-medicine-find-doctors-title-img {
        display: block;
        width: rem(163);
        height: rem(30);
        margin-right: rem(30);
        margin-left: rem(106);
      }
    }
    .chinese-medicine-find-doctors-item-wrapper {
      display: grid;
      grid-row-gap: rem(9);
      grid-column-gap: rem(9);
      grid-template-columns: 1fr 1fr; /* 创建两列等宽的网格 */
      padding: rem(10);
      padding-top: 0;
      .chinese-medicine-find-doctors-list-item {
        position: relative;
        width: rem(173);
        height: rem(130);
        background-repeat: no-repeat;
        background-size: cover;
        .chinese-medicine-find-doctors-goodat {
          position: absolute;
          top: rem(60);
          left: rem(10);
          display: -webkit-box;
          width: rem(154);
          overflow: hidden;
          color: #999;
          font-size: 12px;
          line-height: 16px;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .chinese-medicine-find-doctors-price {
          position: absolute;
          bottom: rem(12);
          left: rem(12);
          color: #ff6134;
          font-weight: 600;
          font-size: 14px;
        }
        .chinese-medicine-find-doctors-price-qi {
          color: #999;
          font-weight: 400;
          font-size: 10px;
        }
      }
    }
  }
  .chinese-medicine-knowledge {
    position: relative;
    margin-top: rem(15);
    .chinese-medicine-knowledge-title {
      display: block;
      width: rem(163);
      height: rem(30);
      margin: 0 auto;
    }
    .chinese-medicine-knowledge-swiper {
      height: rem(200);
      margin-top: rem(13);
      .chinese-medicine-knowledge-swiper-img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .chinese-medicine-prescribe {
    margin-top: rem(25);
    .chinese-medicine-prescribe-title {
      display: block;
      width: rem(163);
      height: rem(30);
      margin: 0 auto;
    }
    .chinese-medicine-prescribe-content {
      padding: rem(12.5) rem(10) 0 rem(10);
      .chinese-medicine-prescribe-content-intro {
        display: block;
        width: rem(355);
        height: rem(260);
      }
      .chinese-medicine-prescribe-content-bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        height: rem(40);
        color: #323232;
        font-size: 12px;
        line-height: rem(40);
        text-align: center;
        background: #fffcf6;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 -1px 0 0 rgba(124, 50, 18, 0.17);
        .chinese-medicine-prescribe-content-bottom-button {
          height: rem(19);
          margin-left: rem(10.75);
          padding: 0 rem(5);
          color: #fff;
          font-size: 12px;
          line-height: rem(19);
          text-align: center;
          background-image: linear-gradient(-35deg, #51c890 0%, #0ab78b 100%);
          border-radius: rem(13);
        }
      }
    }
  }
  .chinese-medicine-science-article {
    margin-top: rem(25);
    padding: 0 rem(10);
    .chinese-medicine-science-article-title {
      display: block;
      width: rem(163);
      height: rem(30);
      margin: 0 auto;
    }
    .chinese-medicine-science-article-split {
      width: rem(325);
      height: 1px; /* 设置一个默认的高度，可以是1像素 */
      margin-top: rem(15);
      background-color: rgba(151, 151, 151, 0.2);
      transform: scaleY(0.5);
    }
    .chinese-medicine-science-article-list {
      margin-top: rem(11.5);
      padding: rem(13.88);
      background: #fff;
      border-radius: 4px;
      .chinese-medicine-science-article-item {
        margin-bottom: rem(15);
        color: #999;
        font-size: 12px;
        .marginleft5 {
          margin-left: rem(5);
        }
        .chinese-medicine-science-article-item-title {
          color: #323232;
          font-weight: bold;
          font-size: 16px;
        }
        .chinese-medicine-science-article-item-info {
          display: flex;
          align-items: center;
          margin-top: rem(8);
          .chinese-medicine-science-article-item-avatar {
            width: rem(23);
            height: rem(23);
            border-radius: 50%;
          }
        }
      }
    }
  }
  .chinese-medicine-bottom-img {
    width: 100%;
    height: rem(146);
    object-fit: contain;
  }
}
.swiper-pagination {
  bottom: rem(0);
  left: 50%;
  transform: translateX(-50%);
}
::v-deep .swiper-pagination-bullet {
  width: rem(7);
  height: rem(7);
  margin-right: rem(3);
  background: #995638;
  border-radius: 50%;
  &.swiper-pagination-bullet-active {
    width: rem(20);
    background: #995638;
    border-radius: 4px;
  }
}
// 定制cubi-css
::v-deep .swiper-slide {
  //   width: rem(290) !important; /*设为固定值*/
  //   width: auto !important; /*根据内容调整宽度*/
  height: rem(181.5);
}
::v-deep .cube-scroll-nav-bar {
  background-color: rgb(248, 244, 235);
}
::v-deep .cube-scroll-nav-bar-item_active {
  color: #7c3212;
  font-weight: bold;
  font-size: 15px;
}
::v-deep .cube-scroll-nav-bar-item_active span {
  position: relative;
}
::v-deep .cube-scroll-nav-bar-item_active span::after {
  position: absolute;
  bottom: -5px;
  left: 5px;
  display: block;
  width: 50px;
  height: 2px;
  background: #7c3212;
  content: '';
}
</style>
